import { BaseService } from "./BaseService";

export class RequestService extends BaseService {

    constructor(url) {
        super(url);
    }

    async createRequest(params) {
        return this.create(params);
    }

    async getRequests(filter, username, allRequests) {
        // Modificamos la llamada get para enviar ambos parámetros
        const queryParams = {
            ...filter,  // Pasar el filtro tal como está
            assignedBy: username,  // Añadir el username como 'assignedBy'
            allRequests: allRequests
        };
        return this.get(queryParams);  // Llamar al método 'get' con los parámetros modificados
    }

    async deleteRequests(params) {
        return this.delete(params);
    }

    async createUpdateRequest(params) {
        return this.create(params);
    }

}
